<template>
  <div
    class="logo"
    :class="{ scrolled: $store.state.page.scrolled }"
    data-apollo-hover
    data-apollo-hover-animation="scale-center"
  >
    <router-link :to="`/${$store.state.lang}`" @click.native="$eventHub.$emit('close-menu')">
      <div class="logo__zonin">
        <img src="/static/vector/zonin.svg" alt="Zonin">
      </div>
      <div class="logo__prosecco">
        <img src="/static/vector/prosecco.svg" alt="Prosecco 1821">
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'ComposedLogo',
};
</script>

<style lang="scss" scoped>
.logo {
  width: 100%;

  @include mq($until: ipadP) {
    width: 100px;
  }

  @at-root .loader & {
    @include mq($until: ipadP) {
      width: 60%;
      margin: 0 auto;
    }
  }

  img {
    width: 80%;
    height: calc(100px * var(--rw));
    margin-left: 0px;
    filter: saturate(0%) brightness(200%);
    transition: filter .6s $inOutCubic;

    @at-root .menu-open & {
      filter: none;
    }

    @at-root .page-white & {
      filter: saturate(0%) brightness(0%);
    }

    // Fix for loader not changin color keep white
    @at-root .loader & {
      filter: saturate(0%) brightness(200%);

      @include mq($until: ipadP) {
        width: 100%;
      }
    }
  }

  &__zonin {
    margin-bottom: 5px;
    transition: transform .6s $inOutCubic;
  }

  &__prosecco {
    transition: transform .6s $inOutCubic,
                opacity .6s $inOutCubic;

    @include mq($until: ipadL) {
      position: relative;
      bottom: 25px;
    }
  }

  &.scrolled {
    .logo__prosecco {
      transform: translateY(30px);
      opacity: 0;

      @include mq($until: ipadP) {
        transform: translateY(100%);
      }
    }
  }

  &:hover {
    .logo__zonin {
      transform: translateY(0px);
      opacity: 1;
    }

    .logo__prosecco {
      transform: translateY(0px);
    }
  }
}
</style>
